import { Pipe, PipeTransform } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { CellRow, CellUtil } from '@ddt-web/data-service';
import * as dayjs from 'dayjs';
import * as advancedFormat from 'dayjs/plugin/advancedFormat';
import * as customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);

@Pipe({
	name: 'portfolioDisplayNameRebal'
})
export class PortfolioDisplayNameRebalancePipe implements PipeTransform {
	constructor(private contentService: ContentService) { }

	/**
	 * Returns the transformed portfolio name to display in the provided format.
	 * Portfolio name is the formatted value of the portfolioData with name id.
	 * RebalanceDate is date in rebalance format if date is valid or 'Invalid Date'.
	 *
	 * @param inputDate string date in either format 'MM/DD/YYYY' or 'YYYYMMDD'
	 * @param portfolioData CellRow portfolioData with name id
	 * @param defaultFormat format to display the portfolio name (default to 'MM/DD/YYYY [Allocations]')
	 */
	public transform(inputDate: string, portfolioData: CellRow, defaultFormat: string = 'MM/DD/YYYY [Allocations]'): string {
		const portfolioName = CellUtil.getById(portfolioData, 'name').formattedValue;
		const format = this.contentService.get('MP_ALLOCATION_DATE_FORMAT', defaultFormat);
		let dateString = 'Invalid Date';

		if (inputDate) {
			dateString = dayjs(inputDate, ['MM/DD/YYYY', 'YYYYMMDD'], true).format(format);
		}

		return `${portfolioName} (${dateString})`;
	}
}
